// extracted by mini-css-extract-plugin
module.exports = {"task":"task_task__Le5js"};